import Joi from 'joi';
import PropTypes from 'prop-types';
import Form from '../../common/form';

import * as utils from '../../../utils/utilities';
import * as constants from '../../../utils/constants';
import toastService from '../../../services/toastService';

class MUTIsoPageForm extends Form {
	state = {
		data: { isoImage: [] },
		errors: {},
		loading: false,
		progress: 0,
		places: [],
	};

	static propTypes = {
		initialImages: PropTypes.array,
		onProceed: PropTypes.func,
	};

	schema = {
		isoImage: Joi.array().min(1).max(constants.IMAGE_LIMITS.ISO_IMAGE).required().label('ISO Image'),
	};

	componentDidMount() {
		if (this.props.initialImages) {
			this.setState({ data: { isoImage: this.props.initialImages }});
		}
	}

	doSubmit = (): void => {
		this.props.onProceed(this.state.data.isoImage);
		toastService.success('ISO Image Updated!');
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit} className="p-3">
				{this.renderFileInput({
					max: constants.IMAGE_LIMITS.ISO_IMAGE,
					multiple: constants.IMAGE_LIMITS.ISO_IMAGE > 1,
					name: 'isoImage',
					accept: 'image/*,application/pdf',
					label: 'Images',
					sublabel: 'Upload Isometric Drawing',
					types: utils.getFileUploadTypes(),
					hideCaption: true,
				})}

				<div className="d-flex justify-content-end">
					{this.renderButton('Proceed')}
				</div>
			</form>
		);
	}
}

export default MUTIsoPageForm;
